import React from "react";
import { MINIBASKET } from "../../data/content";
import Reveal from "./Reveal";
import goldPlusImg from "../../assets/gold_plus.webp";
import minibasketImg from "../../assets/minibasket.jpg";

export const Minibasket = () => (
  <section id="minibasket" data-testid="minibasket-section" className="bg-royal text-white py-20 md:py-32 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 order-2 lg:order-1">
        <Reveal y={60}>
          <div className="relative">
            <img
              src={minibasketImg}
              alt="La squadra giovanile della Polisportiva Tricesimo esulta"
              className="w-full h-80 md:h-[520px] object-cover border-4 border-navy"
              data-testid="minibasket-img"
            />
            <div className="absolute -top-5 -right-5 bg-gold text-navy font-heading text-2xl md:text-3xl px-5 py-2 border-4 border-navy hidden sm:block">
              5–11 anni
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 order-1 lg:order-2">
        <Reveal>
          <p className="font-sub uppercase tracking-[0.3em] text-gold font-bold text-sm mb-4">
            {MINIBASKET.kicker}
          </p>
          <h2 className="font-heading uppercase leading-[0.9] text-white text-4xl md:text-6xl tracking-tight">
            {MINIBASKET.title}
          </h2>
          <p className="mt-6 font-body text-lg text-white/85 leading-relaxed max-w-xl">
            {MINIBASKET.text}
          </p>
        </Reveal>

        <div className="mt-10 space-y-px bg-white/20 border border-white/20">
          {MINIBASKET.points.map((p, i) => (
            <Reveal key={p.t} delay={0.06 * i} className="bg-royal">
              <div
                data-testid={`minibasket-level-${p.t}`}
                className="flex items-center justify-between p-5 hover:bg-navy transition-colors"
              >
                <span className="font-sub uppercase font-bold tracking-wide text-lg">{p.t}</span>
                <span className="font-body text-sm text-white/70">{p.d}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 font-sub uppercase tracking-wide text-gold text-sm md:text-base">
            {MINIBASKET.cta}
          </p>
        </Reveal>
      </div>
    </div>

    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 mt-16 md:mt-24">
      <Reveal>
        <div
          data-testid="minibasket-certificate"
          className="border-4 border-navy shadow-hard bg-white overflow-hidden"
        >
          <img
            src={goldPlusImg}
            alt="Certificato di Qualità Minibasket FOR LIFE - Livello GOLD PLUS 2025/26"
            className="w-full h-auto object-cover block"
            data-testid="minibasket-certificate-img"
          />
          <div className="bg-gold text-navy p-8 md:p-10">
            <div className="font-sub uppercase tracking-widest text-court font-bold text-sm mb-2">
              Certificato di Qualità Minibasket · FOR LIFE — Livello GOLD PLUS
            </div>
            <p className="font-body text-base md:text-lg leading-relaxed">
              Ogni anno riceviamo dalla Federazione il Certificato di Qualità Minibasket FOR LIFE –
              Livello GOLD PLUS, per premiare la virtuosità della nostra società e l&apos;attenzione
              quotidiana nel promuovere la pallacanestro nel rispetto delle regole.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Minibasket;
